module.exports = __webpack_public_path__ + "img/esfp.fd300ddc.png";